import { render, staticRenderFns } from "./SmartSpecialisationStrategiesPage.vue?vue&type=template&id=56dce384&scoped=true"
import script from "./SmartSpecialisationStrategiesPage.vue?vue&type=script&lang=js"
export * from "./SmartSpecialisationStrategiesPage.vue?vue&type=script&lang=js"
import style0 from "./SmartSpecialisationStrategiesPage.vue?vue&type=style&index=0&id=56dce384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dce384",
  null
  
)

export default component.exports